import type {
    IconDefinition,
    SizeProp,
} from "@fortawesome/fontawesome-svg-core";
import type { JSXElementConstructor } from "react";
import type { IconPreset } from "./Icon.presets";
import type { CustomIcon, IconType } from "./Icon.types";
import icons from "./Icon.types";

export const defaultIconSize: SizeProp = "1x";

export const iconNames = Object.keys(icons).sort() as IconType[];
export const iconsWithStyles = (
    Object.entries(icons) as [IconType, IconDefinition | CustomIcon][]
).sort(([a], [b]) => a.localeCompare(b));

/**
 * Converts a literal sizing class to a font size.
 * See https://docs.fontawesome.com/web/style/style-cheatsheet#sizing-icons
 */
export const sizeMap: { [key in SizeProp]: string } = {
    "1x": "1em",
    "2x": "2em",
    "3x": "3em",
    "4x": "4em",
    "5x": "5em",
    "6x": "6em",
    "7x": "7em",
    "8x": "8em",
    "9x": "9em",
    "10x": "10em",
    "2xs": "0.5em",
    "xs": "0.75em",
    "sm": "0.875em",
    "lg": "1.25em",
    "xl": "1.5em",
    "2xl": "2em",
};

export const convertLiteralSizingClassToFontSize = (size: SizeProp): string =>
    sizeMap[size] ?? sizeMap[defaultIconSize];

export const isIcon = (
    type: string | JSXElementConstructor<unknown>
): boolean => (type as Partial<IconPreset>).__isIcon === true;
